import { MemeItem } from '../common/scripts/carousel/types/items'
import { initMemeBlock } from '../common/scripts/memes_widget/meme_default'
import MemeCarouselWidget from '../common/scripts/memes_widget/meme_moment'
import { handleTouchEvents } from '../utilities/touchEvent'

import memes_en from '../common/scripts/memes_widget/memes_en'

const getItems = async (dynamic: boolean) => {
  if (dynamic) {
    return await window.CarouselLoader.load<MemeItem>('memes')
  }

  return memes_en
}

const initDefault = async () => {
  if (document.documentElement.getAttribute('data-mp-app-theme') === 'moment') {
    return
  }

  const blocks: HTMLElement[] = Array.from(
    document.querySelectorAll(`.${MemeCarouselWidget.identifier}_widget_block`)
  )

  for (const block of blocks) {
    const isDynamic = block.dataset.mpDynamic === 'true'
    const items = await getItems(isDynamic)

    initMemeBlock(block, items)
  }
}

const initMoment = async () => {
  if (document.documentElement.getAttribute('data-mp-app-theme') !== 'moment') {
    return
  }

  const blocks: HTMLElement[] = Array.from(
    document.querySelectorAll(`.${MemeCarouselWidget.identifier}_widget_block`)
  )

  for (const block of blocks) {
    const isDynamic = block.dataset.mpDynamic === 'true'
    const items = await getItems(isDynamic)

    new MemeCarouselWidget(items, block)
  }
}

const init = () => {
  // noinspection JSIgnoredPromiseFromCall
  initMoment()
  // noinspection JSIgnoredPromiseFromCall
  initDefault()
  handleTouchEvents('[data-mp-block-type="memes_widget_block"] .swiper')
}

// Dynamic content loading requires async.  Need to make sure experiments have finished loading first.
if (window.experimentsLoaded) {
  init()
} else {
  document.addEventListener('experiment:initialized', () => {
    init()
  })
}
